import { jsx as _jsx } from "react/jsx-runtime";
import { AiSummaryList } from '@src/components/Admin/AiSummary/AiSummaryList';
import { DocumentEntity } from 'pe-core-frontend';
/**
 * AiSummary component displays the AI summary of the payment request.
 *
 * @param {AiSummaryProps} props - The properties for the AiSummary component.
 * @param {PaymentRequest} props.paymentRequest - The payment request object containing client and item details.
 *
 * @returns {JSX.Element} The rendered AiSummary component.
 *
 * @component
 *
 * @example
 * // Usage example:
 * <AiSummary paymentRequest={paymentRequest} />
 *
 * @remarks
 * - Displays AI summaries for documents associated with the payment request
 * - Shows loading and error states
 * - Allows triggering AI processing on documents
 *
 * @internal
 */
export const AiSummary = ({ paymentRequest }) => {
    // Get the documents from the payment request
    const docs = paymentRequest.documents.docs?.map(doc => doc.s3Key) ?? [];
    return (_jsx("div", { children: _jsx(AiSummaryList, { clientId: paymentRequest.clientId, docs: docs, documentEntity: DocumentEntity.PAYMENT_REQUESTS, documentEntityId: paymentRequest.id.toString() }) }));
};
